// React import
import React from 'react';
// Styles imports
import './WalletAiStats.css';
import '../../util.css'

class WalletAiStats extends React.Component {

    render () {
        return(
            <div className={"check-wallet__ai-stats-block"}>
                <span className={"check-wallet__ai-stats-text"}>
                    AI features<br/>coming soon
                </span>
            </div>
        );
    }

}

export default WalletAiStats;